import type { FeatureInitApi } from '../feature-init-api';
import type { FeatureInitResponse, FeatureKey, Feature } from '../../types';

/**
 * FeatureInitApi 的 Mock 实现
 * 返回一个 Free 套餐的模拟数据
 */
export class FeatureInitApiMock implements FeatureInitApi {
    private readonly _allFeatureKeys: FeatureKey[] = [
        'feature_foo',
        'feature_bar',
        '查新:查看完整检索结果',
        '查新:查看检索式',
        '查新:查看检索结果',
        '查新:添加手动检索',
        '查新:执行查新检索',
        '查新:编辑权利要求树节点',
        '查新:添加权利要求树节点',
        '查新:删除权利要求树节点',
        '查新:添加专利',
        '说明书:生成',
        '说明书:上传附件',
        '说明书:重新生成',
        '说明书:添加附图',
        '说明书:编辑附图',
        '说明书:切换审查模式',
        '说明书:段落优化',
        '说明书:段落编辑',
    ];

    private readonly _limitedAccessFeatures: FeatureKey[] = [
        '查新:查看检索结果',
        '查新:执行查新检索',
        '说明书:生成',
    ];

    async getFeatureInit(): Promise<FeatureInitResponse> {
        return {
            features: this._buildFreeFeatures(),
            userPlan: {
                planType: 'enterprise',
                planName: '免费套餐',
            },
        };
    }

    private _buildFreeFeatures(): Record<FeatureKey, Feature> {
        const features: Record<FeatureKey, any> = {} as Record<FeatureKey, any>;

        this._allFeatureKeys.forEach((key) => {
            features[key] = this._buildFeature(key);
        });

        return features;
    }

    private _buildFeature(key: FeatureKey): Feature {
        if (this._limitedAccessFeatures.includes(key)) {
            return {
                featureName: key,
                isAvailable: true,
                isQuotaExceeded: false,
            };
        }

        return {
            featureName: key,
            isAvailable: false,
            isQuotaExceeded: false,
        };
    }
}
